import { templateState } from '@/shared/Status'
import { getFormatMessage } from '@/utils/utils'
import { Progress, Radio, Table } from 'antd'
import React, { useEffect, useState } from 'react'
import { BoxJobProps } from '../interface'
import moment from 'moment'

export const BoxJob: React.FC<BoxJobProps> = (props: BoxJobProps) => {
  const [state, setState] = useState<number>()
  const formatMessage = getFormatMessage()
  const states: any = { ...templateState }
  delete states[0]
  const defaultOptions = [
    {
      label: `${formatMessage({ id: 'app.box.job.state.1' })}(0)`,
      value: 1
    },
    {
      label: `${formatMessage({ id: 'app.box.job.state.2' })}(0)`,
      value: 2
    },
    {
      label: `${formatMessage({ id: 'app.box.job.state.3' })}(0)`,
      value: 3
    }
  ]

  const columns = [
    {
      title: formatMessage({ id: 'app.box.job.index' }),
      key: 'app.box.job.index',
      render: (text: any, record: any, index: any) => index + 1
    },
    {
      title: formatMessage({ id: 'app.box.job.type' }),
      key: 'app.box.job.type',
      render: (text: any, record: any, index: any) => {
        return formatMessage({ id: `app.box.job.type.${record.type}` })
      }
    },
    {
      title: formatMessage({ id: 'app.box.job.boxNo' }),
      key: 'app.box.job.boxNo',
      dataIndex: 'boxNo'
    },
    {
      title: formatMessage({ id: 'app.box.job.progress' }),
      key: 'app.box.job.progress',
      render: (text: any, record: any, index: any) => {
        const status: any = formatMessage({
          id: `app.template.progress.status.${record.state}`
        })
        let percent = record.progress
        if (percent < 100 && record.state == 2) {
          percent = 100
        }
        let steps = record.steps <= 0 ? 4 : record.steps
        return <Progress percent={percent} steps={steps} status={status} />
      }
    },
    {
      title: formatMessage({ id: 'app.box.job.message' }),
      key: 'app.box.job.message',
      render: (text: any, record: any, index: any) => {
        return state == 3 && record.code !== 0
          ? formatMessage({ id: `app.device.code.${record.code}` })
          : '-'
      }
    },
    {
      title: formatMessage({ id: 'app.box.job.creationTime' }),
      key: 'app.box.job.creationTime',
      render: (text: any, record: any, index: any) => {
        return moment(record.creationTime).local().format('YYYY-MM-DD HH:mm:ss')
      }
    }
  ]

  const handleChange = (value: number) => {
    setState(value)
    if (props.onSearch) {
      props.onSearch({ state: value })
    }
  }

  useEffect(() => {
    const s = props.state ? props.state : 1
    setState(s)
  }, [props.state])

  return (
    <div>
      <div style={{ marginBottom: 5 }}>
        <Radio.Group
          options={props.options || defaultOptions}
          onChange={(e) => handleChange(e.target.value)}
          optionType='button'
          buttonStyle='solid'
          value={state}
        />
      </div>
      <Table
        rowKey='id'
        columns={columns}
        dataSource={props.data}
        pagination={props.pagination}
        size={props.size}
      />
    </div>
  )
}
